import React, { Fragment } from 'react'
import styles from './Footer.module.scss'
import { Box, Grid, Typography } from '@mui/material'
import img from '../../asserst/logo/Logo.svg'
import { useNavigate } from 'react-router-dom'

import fb from '../../asserst/icons/social/Facebook.png'
import linke from '../../asserst/icons/social/image 68.png'
import twiter from '../../asserst/icons/social/Twitter.png'
import insta from '../../asserst/icons/social/Instagram.png'
import youtube from '../../asserst/icons/social/Youtube.png'
import whatsApp from '../../asserst/img/whatsapp-873316_1280.png'

const allData = {
    mainLinks: [
        { id: 1, name: "Home", path: "/" },
        { id: 2, name: "About", path: "/about" },
        { id: 3, name: "Services", path: "/service" },
        { id: 4, name: "Portfolio", path: "/portfolio" },
        { id: 5, name: "Career", path: "/career" },
        { id: 6, name: "Contact Us", path: "/contact" },
    ],
    socialIcons: [
        { id: 1, path: "https://www.facebook.com/otusonellp", img: fb },
        { id: 2, path: "https://twitter.com/otusonellp", img: twiter },
        { id: 3, path: "https://www.linkedin.com/company/otusone/", img: linke },
        { id: 4, path: "https://www.instagram.com/otusonellp/", img: insta },
        { id: 5, path: "https://wa.me/9340312713", img: whatsApp },
        { id: 6, path: "https://www.youtube.com/channel/UCr-LBe5OxmrgslzkMGJjcpw", img: youtube },
    ],
    legalLinks: [
        { id: 7, name: "Meta Privacy & Policy", path: "/privacy-policy" },
        { id: 8, name: "Meta Terms & Conditions", path: "/terms-and-conditions" }
    ]
};


const Footer = () => {
    const navigation = useNavigate()
    const handleclick = () => {
        window.scrollTo(0, 0)
    }

    return (
        <Fragment>
            <Grid container className={styles.footerContainer}>

                {/* Column 1: Logo */}
                <Grid item xs={12} sm={4} md={2} lg={2} sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center' } }}>
                    <img src={img} alt="footer-logo" onClick={() => navigation("/")} className={styles.footerLogo} />
                </Grid>

                {/* Column 2: Text Description */}
                <Grid item xs={12} sm={8} md={4} lg={4} sx={{ p: { md: 2, lg: 4 } }}>
                    <Typography fontSize={{ xs: 16, sm: 16, md: 13 }} sx={{ textAlign: "justify" }}>
                        Outstanding software<br />
                        development company!<br />
                        Exceptional expertise,<br />
                        timely delivery, and <br />
                        seamless communication.<br />
                        Highly recommended <br />
                        for all your software needs.
                    </Typography>
                </Grid>

                {/* Column 3: All Links (Main, Legal, and Social) */}
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ pl: { sm: 2, md: 0 } }}>
                    <Grid container spacing={2}>

                        {/* Main Links - split into 2 equal columns */}
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                {allData.mainLinks.slice(0, 3).map((item) => (
                                    <Typography
                                        key={item.id}
                                        onClick={() => { navigation(item.path); handleclick() }}
                                        fontSize={13}
                                        fontWeight={600}
                                        sx={{
                                            color: "#545454",
                                            marginBlock: 0.8,
                                            cursor: "pointer",
                                            textAlign: "left",
                                        }}
                                    >
                                        {item.name}
                                    </Typography>
                                ))}
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                {allData.mainLinks.slice(3).map((item) => (
                                    <Typography
                                        key={item.id}
                                        onClick={() => { navigation(item.path); handleclick() }}
                                        fontSize={13}
                                        fontWeight={600}
                                        sx={{
                                            color: "#545454",
                                            marginBlock: 0.8,
                                            cursor: "pointer",
                                            textAlign: "left",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {item.name}
                                    </Typography>
                                ))}
                            </Box>
                        </Grid>

                        {/* Legal Links & Social Icons */}
                        <Grid item xs={12} sm={4}>
                            <Box>
                                {allData.legalLinks.map((item) => (
                                    <Typography
                                        key={item.id}
                                        onClick={() => { navigation(item.path); handleclick() }}
                                        fontSize={13}
                                        fontWeight={600}
                                        sx={{
                                            color: "#545454",
                                            marginBlock: 0.8,
                                            cursor: "pointer",
                                            textAlign: "left",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {item.name}
                                    </Typography>
                                ))}
                            </Box>

                            {/* Social Icons (now placed below "Legal Links") */}
                            <Box mt={{ xs: 4, sm: 8 }}>
                                <Typography fontSize={13} fontWeight={600} sx={{ color: "#545454", mb: 1, textAlign: "left" }}>
                                    Follow Us
                                </Typography>
                                <Grid container spacing={1}>
                                    {allData.socialIcons.map((icon) => (
                                        <Grid item key={icon.id}>
                                            <Box
                                                onClick={() => {
                                                    if (icon.path) {
                                                        window.open(icon.path, "_blank")
                                                    }
                                                }}
                                            >
                                                <img alt="social" src={icon.img} width={20} style={{ cursor: "pointer" }} />
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>

                {/* Powered by text (moved outside the main 3-column layout) */}
                <Grid item xs={12} mt={2} sx={{ textAlign: "center" }}>
                    <Typography fontSize={12} sx={{ color: '#BFBFBF' }}>
                        Powered by OTUSONE LLP
                    </Typography>
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default Footer;